<section id="formulario-roles">
  <div class="modal-header">
    <h4 uni-heading color="primary" class="modal-title">{{ title }}</h4>
    <button uni-icon-button variant="muted" aria-label="Cerrar" (click)="closeModal()">
      <uni-icon name="x"></uni-icon>
    </button>
  </div>
  <div class="modal-body">
    <div class="container">
      <div class="modal-container-spacer">
        <form #formularioPerfiles="ngForm" class="row" [class.submitted]="formularioPerfiles.submitted" (submit)="savePerfil()">
          <!-- <div class="col-md-12">
                <uni-form-field>
                    <uni-label>Nombre:</uni-label>
                    <input uniInput formControlName="nombre" />
                </uni-form-field>
            </div> -->
          <div class="col-md-12">
            <div class="form-group">
              <label for="nombre">Nombre:</label>
              <input
                type="text"
                name="nombre"
                #nombre="ngModel"
                [(ngModel)]="perfil.nombre"
                required
                class="form-control"
                [class.is-invalid]="nombre.invalid && nombre.touched"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="nombre">Descripción:</label>
              <textarea
                name="descripcion"
                #descripcion="ngModel"
                rows="4"
                [(ngModel)]="perfil.descripcion"
                required
                class="form-control"
                [class.is-invalid]="descripcion.invalid && descripcion.touched"
              ></textarea>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="opcionRol">Roles:</label>
              <ng-select
                name="perfilRoleId"
                #perfilRoleId="ngModel"
                [items]="roles"
                bindLabel="nombre"
                bindValue="id"
                [multiple]="true"
                [(ngModel)]="perfil.perfilRoleId"
                placeholder="Seleccione los roles deseados"
                [class.is-invalid]="perfilRoleId.invalid && perfilRoleId.touched"
                required
              >
              </ng-select>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button uni-button fill="outline" variant="secondary" (click)="closeModal()">Cancelar</button>
    <button uni-button [disabled]="formularioPerfiles.invalid" (click)="savePerfil()">Guardar</button>
  </div>
</section>
